import type { AcceptNode, SigneNode } from 'entities/document/model';
import { participantIsDone } from './participant-is-done';

export const nodeIsDone = (node: AcceptNode | SigneNode) => {
  const { participants } = node.parameters;
  return participants?.length ? participants.every(participantIsDone) : false;
};
